import React from "react";
import { Link } from "react-router-dom";

export default function PrivacyPolicy() {
  return (
    <section className="py-10 bg-white">
      <div className="max-w-[1100px] mx-auto px-4 prose prose-slate">
        <h1>Datenschutzerklärung</h1>
        <p>
          Diese Datenschutzerklärung informiert Sie gemäß Art. 13 DSGVO über die
          Verarbeitung personenbezogener Daten beim Besuch unserer Website und bei
          Kontaktanfragen.
        </p>

        <h2>Verantwortlicher</h2>
        <p>
          <strong>Daraa Umzug</strong>
          <br />
          Inhaber: Mohammad Alshabani
          <br />
          Alt-Friedrichsfelde 68
          <br />
          10315 Berlin
          <br />
          Deutschland
          <br />
          E-Mail:{" "}
          <a href="mailto:mohammadalshabani@icloud.com">
            mohammadalshabani@icloud.com
          </a>
        </p>

        <h2>Hosting und Server-Logfiles</h2>
        <p>
          Diese Website wird bei der <strong>Hostinger</strong> gehostet. Beim Aufruf
          unserer Website werden durch den Hosting-Anbieter automatisch Informationen
          in sogenannten Server-Logfiles verarbeitet. Dies sind insbesondere IP-Adresse,
          Datum und Uhrzeit des Zugriffs, aufgerufene Seite/Datei, Browsertyp und
          Betriebssystem.
        </p>
        <p>
          Die Verarbeitung erfolgt zur Gewährleistung eines sicheren und stabilen
          Betriebs der Website (z. B. Fehleranalyse, Abwehr von Angriffen) auf Grundlage
          von Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse).
        </p>
        <p>
          Soweit erforderlich, erfolgt die Verarbeitung durch Hostinger als
          Auftragsverarbeiter auf Grundlage von Art. 28 DSGVO.
        </p>

        <h2>Kontaktaufnahme</h2>
        <p>
          Wenn Sie uns per E-Mail oder über ein Kontaktformular kontaktieren, verarbeiten
          wir die von Ihnen übermittelten Daten (z. B. Name, E-Mail-Adresse, Telefonnummer
          und Nachrichteninhalt), um Ihre Anfrage zu beantworten und ggf. ein Angebot zu
          erstellen.
        </p>
        <p>
          Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO (vorvertragliche Maßnahmen) und
          – soweit einschlägig – Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an
          effizienter Kommunikation).
        </p>

        <h2>Cookies</h2>
        <p>
          Wir verwenden nur technisch notwendige Cookies, die für den Betrieb der Website
          erforderlich sind. Sofern wir nicht notwendige Cookies/Tracker einsetzen,
          erfolgt dies nur nach Ihrer Einwilligung gemäß § 25 TTDSG.
        </p>
        <p>
          Hinweise zu Cookies und ggf. Änderungen/Widerruf Ihrer Einwilligung finden Sie in
          unserer <Link to="/cookies">Cookie-Richtlinie</Link>.
        </p>

        <h2>Empfänger / Auftragsverarbeiter</h2>
        <p>
          Eine Weitergabe Ihrer Daten an Dritte erfolgt nur, soweit dies zur Bereitstellung
          der Website oder zur Bearbeitung Ihrer Anfrage erforderlich ist (z. B. Hosting-
          und E-Mail-Dienstleister). Sofern Dienstleister als Auftragsverarbeiter tätig
          werden, erfolgt dies auf Grundlage von Verträgen nach Art. 28 DSGVO.
        </p>

        <h2>Speicherdauer</h2>
        <p>
          Wir verarbeiten personenbezogene Daten nur solange, wie es für die jeweiligen
          Zwecke erforderlich ist oder gesetzliche Pflichten bestehen. Danach werden die
          Daten gelöscht oder anonymisiert.
        </p>

        <h2>Ihre Rechte</h2>
        <ul>
          <li>Auskunft (Art. 15 DSGVO)</li>
          <li>Berichtigung (Art. 16 DSGVO)</li>
          <li>Löschung (Art. 17 DSGVO)</li>
          <li>Einschränkung der Verarbeitung (Art. 18 DSGVO)</li>
          <li>Datenübertragbarkeit (Art. 20 DSGVO)</li>
          <li>Widerspruch (Art. 21 DSGVO)</li>
          <li>Widerruf von Einwilligungen (Art. 7 DSGVO)</li>
          <li>
            Beschwerde bei einer Datenschutzaufsichtsbehörde (z. B. Berliner Beauftragte
            für Datenschutz und Informationsfreiheit)
          </li>
        </ul>

        <h2>Kontakt Datenschutz</h2>
        <p>
          Fragen zum Datenschutz:{" "}
          <a href="mailto:mohammadalshabani@icloud.com">
            mohammadalshabani@icloud.com
          </a>
        </p>

        <h3>Bildnachweise</h3>
        <p>
          <a
            href="https://de.freepik.com/fotos-kostenlos/junger-kurier-und-sein-kollege-entladen-kartons-aus-lieferwagen_25630693.htm"
            target="_blank"
            rel="noreferrer"
          >
            Freepik
          </a>{" "}
          von{" "}
          <a
            href="https://de.freepik.com/autor/drazenzigic"
            target="_blank"
            rel="noreferrer"
          >
            Drazen Zigic
          </a>
        </p>

        <p className="text-sm opacity-70">
          Stand: Dezember 2025 — Hinweis: Diese Informationen ersetzen keine Rechtsberatung.
        </p>
      </div>
    </section>
  );
}
